export interface HeaderToolbarState {
    isNavigateOnClickEnabled: boolean;
}

export const seHeaderToolbarInitialState: HeaderToolbarState = {
    isNavigateOnClickEnabled: true,
};
